var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-component message-block experimental-notice"},[_c('strong',[_vm._v("Experimental")]),_c('p',[_vm._v("Please note that this "+_vm._s(_vm.entity)+" is experimental with the potential for major things to change. Feel encouraged to try it out and give feedback, but refrain from using it in production.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }